<ng-container *ngrxLet="selectProductByRoleDict$; let p">
  <!-- EARLY ADOPTER PLAN -->
  <div>
    <div class="tier-name">
      {{ p[roles.EARLY_ADOPTER]?.name?.toUpperCase() }}
    </div>
    <!--    <div-->
    <!--      [ngClass]="{-->
    <!--        'trial-header': trialText(p[roles.EARLY_ADOPTER]?.metadata?.trial)?-->
    <!--          .length-->
    <!--      }">-->
    <!--      <span *ngIf="p[roles.EARLY_ADOPTER].stripe_metadata_trial">{{-->
    <!--        trialText(p[roles.EARLY_ADOPTER].stripe_metadata_trial)-->
    <!--      }}</span>-->
    <!--    </div>-->

    <div class="price">
      <ng-container *ngrxLet="selectPriceByMonthDict$; let p">
        <div class="tier-monthly-price accent">
          {{ formatCurrency(p[roles.EARLY_ADOPTER]) }} / Month
        </div>
        <div class="or">or</div>
      </ng-container>

      <ng-container *ngrxLet="selectPriceByYearDict$; let p">
        <div class="">
          <span class="tier-yearly-price accent"
            >{{ formatCurrency(p[roles.EARLY_ADOPTER]) }} / Year</span
          >
        </div>
      </ng-container>
    </div>

    <div class="description" data-role="early-adopter">
      Terms and conditions apply to<br />becoming an early adopter.
    </div>

    <div class="push-bottom-20" data-role="early-adopter">
      <button mat-flat-button color="primary" (click)="learnMoreEarlyAdopter()">
        LEARN MORE
      </button>
    </div>

    <div class="storage">
      <div class="title">STORAGE</div>
      <ng-container *ngrxLet="selectProductByRoleDict$; let p">
        <div class="title">
          {{ p[roles.EARLY_ADOPTER]?.metadata?.baseStorageGB | storage
          }}<sup>*</sup>
        </div>
      </ng-container>
    </div>

    <div
      class="feature"
      *ngFor="let t of dawDataOnly$ | ngrxPush; let odd = odd"
      [ngClass]="{odd: odd}">
      <div class="feature-name">
        {{ t.featureName }}
        <span class="feature-description">{{ t.description }}</span>
      </div>
      <div class="">
        <mat-icon *ngIf="t[roles.EARLY_ADOPTER]">check</mat-icon>
      </div>
    </div>

    <div class="title">COLLABORATION FEATURES</div>
    <div
      class="feature"
      *ngFor="let t of collaborationDataOnly$ | ngrxPush; let odd = odd"
      [ngClass]="{odd: odd}">
      <div class="feature-name">
        {{ t.featureName }}
        <span class="feature-description">{{ t.description }}</span>
      </div>
      <div class="">
        <mat-icon *ngIf="t[roles.EARLY_ADOPTER]">check</mat-icon>
      </div>
    </div>

    <div class="title">ADD ONS</div>
    <div class="feature">
      <div class="feature-name">Additional Storage</div>
      <ng-container *ngrxLet="selectStorageAddonMonthly$; let a">
        <ng-container *ngIf="a">
          <div class="tier-yearly-price accent">
            {{ formatCurrency(a) }} / {{ a.interval_count | storage }} /
            {{ a.interval }}
          </div>
        </ng-container>
      </ng-container>
    </div>
  </div>

  <!-- REVIEWER PLAN -->
  <div class="push-top-30">
    <div class="tier-name">
      {{ p[roles.COLLABORATOR]?.name?.toUpperCase() }}
    </div>
    <!--    <div-->
    <!--      [ngClass]="{-->
    <!--        'trial-header ': trialText(p[roles.COLLABORATOR]?.stripe_metadata_trial)-->
    <!--          .length-->
    <!--      }">-->
    <!--      <span *ngIf="p[roles.COLLABORATOR].stripe_metadata_trial">{{-->
    <!--        trialText(p[roles.COLLABORATOR].stripe_metadata_trial)-->
    <!--      }}</span>-->
    <!--    </div>-->

    <div class="price">
      <div class="tier-monthly-price accent">FREE</div>
    </div>
    <!-- TODO KEEP -->
    <!--    <ng-container *ngrxLet="selectPriceByYearDict$; let p">-->
    <!--    </ng-container>-->

    <div class="description" data-role="reviewer">
      Contribute to other projects only. All costs for contribution are the
      project owner's responsibility.
    </div>

    <div class="description" data-role="reviewer">
      Must be invited to a project as a reviewer.
    </div>

    <div class="storage">
      <div class="title left">STORAGE</div>
      <ng-container *ngrxLet="selectProductByRoleDict$; let p">
        <div class="title">
          {{ p[roles.COLLABORATOR]?.metadata?.baseStorageGB | storage
          }}<sup>*</sup>
        </div>
      </ng-container>
    </div>

    <div
      class="feature"
      *ngFor="let t of dawDataOnly$ | ngrxPush; let odd = odd"
      [ngClass]="{odd: odd}">
      <div class="feature-name">
        {{ t.featureName }}
        <span class="feature-description">{{ t.description }}</span>
      </div>
      <div class="">
        <mat-icon *ngIf="t[roles.COLLABORATOR]">check</mat-icon>
      </div>
    </div>

    <div class="title">COLLABORATION FEATURES</div>
    <div
      class="feature"
      *ngFor="let t of collaborationDataOnly$ | ngrxPush; let odd = odd"
      [ngClass]="{odd: odd}">
      <div class="feature-name">
        {{ t.featureName }}
        <span class="feature-description">{{ t.description }}</span>
      </div>
      <div>
        <mat-icon *ngIf="t[roles.COLLABORATOR]">check</mat-icon>
      </div>
    </div>
  </div>

  <!-- PERSONAL PLAN -->
  <div class="push-top-30">
    <div class="tier-name">{{ p[roles.PERSONAL]?.name?.toUpperCase() }}</div>
    <!--    <div-->
    <!--      [ngClass]="{-->
    <!--        'trial-header': trialText(p[roles.PERSONAL].stripe_metadata_trial)-->
    <!--          .length-->
    <!--      }">-->
    <!--      <span *ngIf="p[roles.PERSONAL].stripe_metadata_trial">{{-->
    <!--        trialText(p[roles.PERSONAL].stripe_metadata_trial)-->
    <!--      }}</span>-->
    <!--    </div>-->

    <div class="price">
      <ng-container *ngrxLet="selectPriceByMonthDict$; let p">
        <div class="tier-monthly-price accent accent">
          {{ formatCurrency(p[roles.PERSONAL]) }} / Month
        </div>
        <div class="or">or</div>
      </ng-container>

      <ng-container *ngrxLet="selectPriceByYearDict$; let p">
        <div class="">
          <span class="tier-yearly-price accent"
            >{{ formatCurrency(p[roles.PERSONAL]) }} / Year</span
          >
          <br /><strong class="accent"
            >( {{ p[roles.PERSONAL].description }} )</strong
          >
        </div>
      </ng-container>
    </div>

    <div class="description" data-role="personal">
      Can invite collaborators and reviewers to your project.
    </div>

    <div class="description left" data-role="personal"></div>

    <div class="storage">
      <div class="title">STORAGE</div>
      <ng-container *ngrxLet="selectProductByRoleDict$; let p">
        <div class="title">
          {{ p[roles.PERSONAL]?.metadata?.baseStorageGB | storage }}<sup>*</sup>
        </div>
      </ng-container>
    </div>

    <div
      class="feature"
      *ngFor="let t of dawDataOnly$ | ngrxPush; let odd = odd"
      [ngClass]="{odd: odd}">
      <div class="feature-name">
        {{ t.featureName }}
        <span class="feature-description">{{ t.description }}</span>
      </div>
      <div>
        <mat-icon *ngIf="t[roles.PERSONAL]">check</mat-icon>
      </div>
    </div>

    <div class="title">COLLABORATION FEATURES</div>

    <div
      class="feature"
      *ngFor="let t of collaborationDataOnly$ | ngrxPush; let odd = odd"
      [ngClass]="{odd: odd}">
      <div class="feature-name">
        {{ t.featureName }}
        <span class="feature-description">{{ t.description }}</span>
      </div>
      <div>
        <mat-icon *ngIf="t[roles.PERSONAL]">check</mat-icon>
      </div>
    </div>

    <div class="title">ADD ONS</div>
    <div class="feature">
      <div class="feature-name">Additional Storage</div>
      <ng-container *ngrxLet="selectStorageAddonMonthly$; let a">
        <ng-container *ngIf="a">
          <div class="tier-yearly-price accent">
            {{ formatCurrency(a) }} / {{ a.interval_count | storage }} /
            {{ a.interval }}
          </div>
        </ng-container>
      </ng-container>
    </div>
  </div>

  <!-- BAND PLAN -->
  <div class="push-top-30 push-bottom-30">
    <div class="tier-name">{{ p[roles.BAND]?.name?.toUpperCase() }}</div>
    <!--    <div-->
    <!--      [ngClass]="{-->
    <!--        'trial-header': trialText(p[roles.BAND].stripe_metadata_trial).length-->
    <!--      }">-->
    <!--      <span *ngIf="p[roles.BAND].stripe_metadata_trial">{{-->
    <!--        trialText(p[roles.BAND].stripe_metadata_trial)-->
    <!--      }}</span>-->
    <!--    </div>-->

    <div class="price">
      <ng-container *ngrxLet="selectPriceByMonthDict$; let p">
        <div class="tier-monthly-price accent">
          {{ formatCurrency(p[roles.BAND]) }} / Month
        </div>
        <div class="or">or</div>
      </ng-container>

      <ng-container *ngrxLet="selectPriceByYearDict$; let p">
        <div>
          <span class="tier-yearly-price accent"
            >{{ formatCurrency(p[roles.BAND]) }} / Year</span
          >
          <br /><strong class="accent"
            >( {{ p[roles.PERSONAL].description }} )</strong
          >
        </div>
      </ng-container>
    </div>

    <div class="description" data-role="band">
      Can invite collaborators and reviewers to your project.
    </div>

    <div class="storage">
      <div class="title">STORAGE</div>
      <ng-container *ngrxLet="selectProductByRoleDict$; let p">
        <div class="title">
          {{ p[roles.BAND]?.metadata?.baseStorageGB | storage }}<sup>*</sup>
        </div>
      </ng-container>
    </div>

    <div
      class="feature"
      *ngFor="let t of dawDataOnly$ | ngrxPush; let odd = odd"
      [ngClass]="{odd: odd}">
      <div class="feature-name">
        {{ t.featureName }}
        <span class="feature-description">{{ t.description }}</span>
      </div>
      <div>
        <mat-icon *ngIf="t[roles.BAND]">check</mat-icon>
      </div>
    </div>
    <div class="title">COLLABORATION FEATURES</div>
    <div
      class="feature"
      *ngFor="let t of collaborationDataOnly$ | ngrxPush; let odd = odd"
      [ngClass]="{odd: odd}">
      <div class="feature-name">
        {{ t.featureName }}
        <span class="feature-description">{{ t.description }}</span>
      </div>
      <div>
        <mat-icon *ngIf="t[roles.BAND]">check</mat-icon>
      </div>
    </div>
    <div class="title addons">ADD ONS</div>
    <div class="feature">
      <div class="feature-name">Additional Storage</div>
      <ng-container *ngrxLet="selectStorageAddonMonthly$; let a">
        <ng-container *ngIf="a">
          <div class="tier-yearly-price accent">
            {{ formatCurrency(a) }} / {{ a.interval_count | storage }} /
            {{ a.interval }}
          </div>
        </ng-container>
      </ng-container>
    </div>
  </div>
</ng-container>
